import Component from '@glimmer/component';

import type {
  BarData,
  SymmetryData,
} from '../../../types/components/prism/data-bar.ts';
import {
  COLOR_TEXT_CRITICAL,
  COLOR_TEXT_DEFAULT,
  COLOR_TEXT_SUCCESS,
  COLOR_TRAFFIC_LIGHT_NEGATIVE,
  COLOR_TRAFFIC_LIGHT_POSITIVE,
  getCssVariableValue,
} from '../../../utils/css-variable.ts';
import PrismDataBarDataBarLabelValueTarget from './data-bar-label-value-target.gts';

interface PrismDataBarDataBarSymmetricWithLabelAndValueSignature {
  Args: {
    data: SymmetryData;
  };
  Element: HTMLDivElement;
}

export default class PrismDataBarDataBarSymmetricWithLabelAndValue extends Component<PrismDataBarDataBarSymmetricWithLabelAndValueSignature> {
  defaultColor = getCssVariableValue(COLOR_TEXT_DEFAULT);
  negativeBackgroundColor = getCssVariableValue(COLOR_TRAFFIC_LIGHT_NEGATIVE);
  negativeTextColor = getCssVariableValue(COLOR_TEXT_CRITICAL);
  positiveBackgroundColor = getCssVariableValue(COLOR_TRAFFIC_LIGHT_POSITIVE);
  positiveTextColor = getCssVariableValue(COLOR_TEXT_SUCCESS);

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get negativeData() {
    return [
      {
        widthPercentage: this.args.data.negativeWidthPercentage,
        backgroundColor: this.negativeBackgroundColor,
      },
    ];
  }

  get positiveData(): BarData[] {
    return [
      {
        widthPercentage: this.args.data.positiveWidthPercentage,
        backgroundColor: this.positiveBackgroundColor,
      },
    ];
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get valueColor() {
    if (this.args.data.value < 0) {
      return this.negativeTextColor;
    }

    if (this.args.data.value > 0) {
      return this.positiveTextColor;
    }

    return this.defaultColor;
  }

  <template>
    <div class="prism-data-bar-symmetric-with-value">
      <PrismDataBarDataBarLabelValueTarget
        @data={{this.negativeData}}
        @direction="reverse"
        @rounded="left"
        as |DataBar|
      >
        <DataBar.label @color={{@data.labelColor}} @text={{@data.label}} />
      </PrismDataBarDataBarLabelValueTarget>

      <PrismDataBarDataBarLabelValueTarget
        @data={{this.positiveData}}
        @rounded="right"
        as |DataBar|
      >
        <DataBar.value
          @color={{this.valueColor}}
          @text={{@data.formattedValue}}
          @tooltip={{@data.valueTooltip}}
        />
      </PrismDataBarDataBarLabelValueTarget>
    </div>
  </template>
}
